(() => {
  if (window.__velomintCardSwatchesBoundV5) return;
  window.__velomintCardSwatchesBoundV5 = true;

  const SWATCH='[data-velomint-card-swatch]';
  const CONTAINER='[data-velomint-card-colors]';
  const RULES=[
    {keys:['AZUL CELESTE','CELESTE','SKY BLUE','LIGHT BLUE'],label:'Azul celeste',color:'#38bdf8'},
    {keys:['AZUL MARINO','NAVY','MIDNIGHT BLUE'],label:'Azul marino',color:'#172554'},
    {keys:['VERDE LIMA','LIME'],label:'Verde lima',color:'#84cc16'},
    {keys:['NEGRO','BLACK','BLK','NERO','NOIR'],label:'Negro',color:'#111111'},
    {keys:['BLANCO','WHITE','WHT','BIANCO','IVORY','MARFIL','PEARL WHITE'],label:'Blanco',color:'#ffffff'},
    {keys:['ANTRACITA','ANTHRACITE','GRAPHITE','CHARCOAL','TITANIUM'],label:'Antracita',color:'#4b5563'},
    {keys:['GRIS','GRAY','GREY','GRIGIO','GRY'],label:'Gris',color:'#9ca3af'},
    {keys:['TURQUESA','TURQUOISE','AQUA','CYAN','TEAL','PETROL'],label:'Turquesa',color:'#22aeb3'},
    {keys:['AZUL','BLUE','BLU','GROUPAMA'],label:'Azul',color:'#2563eb'},
    {keys:['MENTA','MINT'],label:'Menta',color:'#6ee7b7'},
    {keys:['VERDE','GREEN','GRN','JUNGLE','OLIVE','OLIVA','KHAKI','KAKI'],label:'Verde',color:'#22c55e'},
    {keys:['AMARILLO','YELLOW','GIALLO','YEL'],label:'Amarillo',color:'#facc15'},
    {keys:['NARANJA','ORANGE','ARANCIO','ORA'],label:'Naranja',color:'#f97316'},
    {keys:['GRANATE','BURDEOS','BURGUNDY','BORDEAUX','MAROON'],label:'Granate',color:'#7f1d1d'},
    {keys:['CORAL'],label:'Coral',color:'#fb7185'},
    {keys:['ROJO','RED','ROSSO'],label:'Rojo',color:'#ef4444'},
    {keys:['ROSA','PINK','ROSE','PNK'],label:'Rosa',color:'#ec4899'},
    {keys:['LILA','LAVANDA','LILAC','LAVENDER'],label:'Lila',color:'#c084fc'},
    {keys:['MORADO','VIOLETA','PURPLE','VIOLET','PUR','ELDERBERRY','AUBERGINE','PLUM'],label:'Morado',color:'#8b5cf6'},
    {keys:['CREMA','CREAM'],label:'Crema',color:'#f1e6c8'},
    {keys:['BEIGE','ARENA','SAND','DUNE','TAUPE'],label:'Beige',color:'#d6c6a5'},
    {keys:['MARRON','BROWN','BRN','CAFE','CHOCOLATE'],label:'Marrón',color:'#8b5e3c'},
    {keys:['DORADO','ORO','GOLD'],label:'Dorado',color:'#d4af37'},
    {keys:['PLATA','SILVER','CHROME'],label:'Plata',color:'#c0c0c0'},
    {keys:['COBRE','COPPER','BRONZE'],label:'Cobre',color:'#b87333'}
  ];

  const norm=v=>String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/\s+/g,' ').trim();
  const esc=v=>v.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
  const has=(text,key)=>new RegExp(`(^|[^A-Z])${esc(key)}(?=$|[^A-Z])`).test(text);
  const explicitName=name=>{const n=norm(name);return n.includes('COLOR')||n.includes('COLOUR')||n.includes('COLORE')||n.includes('COULEUR')};

  function clean(raw){
    let v=norm(raw);
    v=v.replace(/\bQ\d+\b/g,' ');
    v=v.replace(/\b(?:TALLA|SIZE|T)\s*\.?\s*[:\-]?\s*(?:XXS|XS|S|M|L|XL|XXL|[2-8]XL)\b/g,' ');
    v=v.replace(/(?:^|[\s,_+\-/])(?:XXS|XS|S|M|L|XL|XXL|[2-8]XL)(?=$|[\s,_+\-/])/g,' ');
    v=v.replace(/\b(?:TALLA|SIZE)\s*\.?\s*[:\-]?\s*\d{2,3}\b/g,' ');
    v=v.replace(/\b\d{2,3}\s*[-/]\s*(?:XXS|XS|S|M|L|XL|XXL|[2-8]XL)\b/g,' ');
    v=v.replace(/\b20\d{2}\b/g,' ');
    return v.replace(/^[\s,/_+\-]+|[\s,/_+\-]+$/g,'').replace(/\s+/g,' ').trim();
  }

  function parsedColor(raw){
    const text=clean(raw);
    if(!text)return null;
    if(/MULTICOLOR|MULTI COLOR|RAINBOW|ARCOIRIS/.test(text))return{key:'MULTICOLOR',label:'Multicolor',background:'conic-gradient(#ef4444,#f59e0b,#eab308,#22c55e,#06b6d4,#3b82f6,#8b5cf6,#ef4444)'};
    if(/CAMO|CAMUFLAJE/.test(text))return{key:'CAMO',label:'Camuflaje',background:'linear-gradient(135deg,#4d5d3a 0 33%,#8a7b4f 33% 66%,#343b2b 66%)'};
    let found=[];
    RULES.forEach(r=>{if(r.keys.some(k=>has(text,k))&&!found.some(x=>x.label===r.label))found.push(r)});
    if(!found.length)return null;
    const labels=new Set(found.map(x=>x.label));
    if(labels.has('Azul celeste')||labels.has('Azul marino'))found=found.filter(x=>x.label!=='Azul');
    if(labels.has('Verde lima'))found=found.filter(x=>x.label!=='Verde');
    found=found.slice(0,2);
    return {key:found.map(x=>x.label).sort().join('|'),label:found.map(x=>x.label).join('/'),background:found.length>1?`linear-gradient(135deg, ${found[0].color} 0 50%, ${found[1].color} 50% 100%)`:found[0].color};
  }

  function infoFor(button){
    const raw=button.dataset.rawValue||button.title||'';
    const parsed=parsedColor(raw);
    if(parsed){
      if(button.dataset.nativeColor)parsed.background=button.dataset.nativeColor;
      if(button.dataset.nativeImage)parsed.image=button.dataset.nativeImage;
      return parsed;
    }
    if(!explicitName(button.dataset.optionName||''))return null;
    const key=clean(raw)||norm(raw);
    if(!key)return null;
    if(button.dataset.nativeColor)return{key:`EXPLICIT:${key}`,label:raw,background:button.dataset.nativeColor};
    if(button.dataset.nativeImage)return{key:`EXPLICIT:${key}`,label:raw,image:button.dataset.nativeImage};
    if(button.dataset.swatchImage)return{key:`EXPLICIT:${key}`,label:raw,image:button.dataset.swatchImage};
    return null;
  }

  function associatedCard(container){
    const inside=container.closest('.card-wrapper');
    if(inside)return inside;
    let node=container.previousElementSibling;
    while(node){
      if(node.matches?.('product-component'))return node.querySelector('.card-wrapper');
      const nested=node.querySelector?.('.card-wrapper');
      if(nested)return nested;
      node=node.previousElementSibling;
    }
    return null;
  }

  function place(container){
    const card=associatedCard(container);
    if(!card)return {card:null,container};

    const existing=[...card.querySelectorAll(CONTAINER)].find(x=>x!==container);
    if(existing){
      container.remove();
      return {card,container:existing,duplicate:true};
    }

    if(!container.closest('.card-wrapper')){
      const target=card.querySelector('.card-information');
      if(target){
        const price=target.querySelector('.price');
        if(price)price.insertAdjacentElement('afterend',container);else target.appendChild(container);
      }
    }
    return {card,container,duplicate:false};
  }

  function process(original){
    if(!original||original.dataset.velomintProcessed==='true')return;
    const placed=place(original);
    if(placed.duplicate){
      if(placed.container.dataset.velomintProcessed!=='true')process(placed.container);
      return;
    }
    const container=placed.container;
    const buttons=[...container.querySelectorAll(SWATCH)];
    if(!buttons.length){container.hidden=true;container.dataset.velomintProcessed='true';return;}
    const unique=new Map();
    buttons.forEach(button=>{
      button.hidden=true;button.style.display='none';
      const info=infoFor(button);
      if(!info)return;
      const prior=unique.get(info.key);
      if(!prior||(!prior.button.dataset.imageSrc&&button.dataset.imageSrc))unique.set(info.key,{button,info});
    });
    const items=[...unique.values()];
    if(!items.length){container.hidden=true;container.style.display='none';container.dataset.velomintProcessed='true';return;}
    items.slice(0,7).forEach(({button,info})=>{
      button.hidden=false;button.style.display='inline-block';button.style.backgroundImage='none';button.style.backgroundSize='';button.style.backgroundPosition='';
      if(info.image){button.style.background='#fff';button.style.backgroundImage=`url("${info.image}")`;button.style.backgroundSize='cover';button.style.backgroundPosition='center';}
      else button.style.background=info.background;
      button.title=info.label;button.setAttribute('aria-label',`Ver color ${info.label}`);
      const t=button.querySelector('.visually-hidden');if(t)t.textContent=info.label;
    });
    const more=container.querySelector('.velomint-card-colors__more');
    if(more){const n=Math.max(items.length-7,0);more.textContent=n?`+${n}`:'';more.hidden=!n;}
    container.hidden=false;container.style.display='flex';container.dataset.velomintProcessed='true';
  }

  function cleanupCards(root=document){
    root.querySelectorAll?.('.card-wrapper').forEach(card=>{
      const containers=[...card.querySelectorAll(CONTAINER)];
      containers.slice(1).forEach(x=>x.remove());
    });
  }

  function scan(root=document){
    root.querySelectorAll?.(CONTAINER).forEach(process);
    cleanupCards(root);
  }

  function activate(button){
    const card=button.closest('.card-wrapper');if(!card)return;
    const img=card.querySelector('.card__media .media > img:first-of-type'),src=button.dataset.imageSrc,srcset=button.dataset.imageSrcset;
    if(img&&src){img.setAttribute('src',src);if(srcset)img.setAttribute('srcset',srcset);if(button.dataset.imageAlt)img.setAttribute('alt',button.dataset.imageAlt);img.style.opacity='1';const media=card.querySelector('.card__media .media');if(media)media.querySelectorAll(':scope > img').forEach((x,i)=>{if(i>0)x.style.opacity='0'})}
    card.querySelectorAll(SWATCH).forEach(x=>{const active=x===button;x.setAttribute('aria-pressed',active?'true':'false');x.style.boxShadow=active?'0 0 0 2px rgb(var(--color-background)), 0 0 0 3px rgb(var(--color-foreground))':'none'});
    const id=button.dataset.variantId;if(id)card.querySelectorAll('a.full-unstyled-link').forEach(link=>{try{const u=new URL(link.href,location.origin);u.searchParams.set('variant',id);link.href=u.toString()}catch(_){}})
  }

  document.addEventListener('pointerover',e=>{const b=e.target.closest?.(SWATCH);if(b)activate(b)});
  document.addEventListener('focusin',e=>{const b=e.target.closest?.(SWATCH);if(b)activate(b)});
  document.addEventListener('click',e=>{const b=e.target.closest?.(SWATCH);if(!b)return;e.preventDefault();e.stopPropagation();activate(b)});
  const start=()=>{scan();new MutationObserver(records=>records.forEach(r=>r.addedNodes.forEach(n=>{if(!(n instanceof Element))return;if(n.matches?.(CONTAINER))process(n);else scan(n)}))).observe(document.documentElement,{childList:true,subtree:true})};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
